import CountriesWeServe from "./CountriesWeServe";
import HeroAuto from "./HeroAuto";
import Fields from "./home/form";
import Testimonialsdummy from "./TestimonialsDummy";
import BlogsSection from "./BlogsSection";
import CampusIntro from "./home/Campus";
import WorkflowSection from "./home/workflow";
//import VisaJourney from "./home/VisaJourney";
import WhyChooseUs from "./home/WhyChooseUs";
import Launch from "./home/Launch";
import Info from "./home/info";
import Co from "./home/Co";
import HeroBelow from "./home/HeroBelow";
//import CoreFeatures from "./home/CoreFeatures";
//import StatsCounter from "./home/StatsCounter";
import Cards from "./home/Offer";
import StudySteps from "./home/StudySteps";
export default function Home() {
  return (
    <>
        <HeroAuto />
        <HeroBelow />
        <CampusIntro />
        <Fields />
        <WhyChooseUs />
        <WorkflowSection />
          <Co/>
        <CountriesWeServe />
         <StudySteps />
        <Launch />
        <Info />
         {/*<CoreFeatures />*/}
         <Cards />  
        {/* <VisaJourney /> */}
        
        <Testimonialsdummy />
        {/*<StatsCounter />*/}
        <BlogsSection />
    </>
  );
}
